import { useDispatch } from "react-redux";
import { updateConfig } from "../../../store/slices/User/UserList/userSlice";
import { useSelector } from "react-redux";

const useUserDetailView = () => {
  const dispatch = useDispatch();
  const { activeId } = useSelector((state) => state.user);
  /*
    The tab carries its own id, so switch on that rather than on its label. Matching names
    meant every new tab needed a branch adding here as well as in the view, and a tab whose
    name was missed silently did nothing on click - which is how Subscriptions shipped
    looking like a customer with no plans rather than a tab that never opened.
  */
  const handleClick = (e) => {
    if (!e?.id) {
      return;
    }
    dispatch(updateConfig((state) => (state.activeId = e.id)));
  };
  return { activeId, handleClick };
};

export default useUserDetailView;
